import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ApiConnect from "../../../../Utils/ApiConnect";
import { connect } from "react-redux";
import { CustomerCustomersList } from "../../../../redux/actions/Modules.Action";
import ReactDatatable from "@ashvin27/react-datatable";
import NewCustomerModal from "./NewCustomerModal";
import DeletePop from "../../../Components/DeletePop";
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ShowModal: false,
      triggerModal: false,
      selectedId: false,
    };
    this.columns = [
      {
        key: "name",
        text: "Customer",
        width: 300,
        sortable: true,
        cell: (record) => {
          return (
            <React.Fragment>
              <div className="d-inline">
                {record.name}{" "}
                {record.register === "1" ? (
                  <span className="material-icons-outlined text-success fs-15">
                    verified
                  </span>
                ) : (
                  ""
                )}
              </div>
            </React.Fragment>
          );
        },
      },
      {
        key: "id",
        text: "Contact",
      },
      {
        key: "otp",
        text: "OTP",
      },
      {
        key: "total_order",
        text: "Total Order",
        sortable: true,
      },
      {
        key: "reward_point",
        text: "Reward Points",
        sortable: true,
      },
      {
        key: "last_visit",
        text: "Last Update",
        sortable: true,
      },
      {
        key: "action",
        text: "Action",
        className: "table-actions",
        width: 150,
        sortable: false,
        align: "center",
        cell: (record) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: record.id, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 30,
      length_menu: [30, 60, 90],
      show_filter: true,
      show_pagination: true,
      button: {
        // excel: true,
        // print: true
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchCustomer();
  }
  fetchCustomer() {
    ApiConnect.get("/Members/Information/CustomerList")
      .then((response) => {
        this.props.CustomerCustomersList(response.data.data);
      })
      .catch((error) => console.log(error));
  }
  handleChange() {}
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Customer List</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <ReactDatatable
                className="table table-separated"
                config={this.config}
                records={this.props.CustomerList}
                columns={this.columns}
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Customer</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <NewCustomerModal />
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeleteCustomer?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchCustomer}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerCustomersList }
)(index);
